import { computed, ref, toRaw, watch } from 'vue'

import axios from 'axios'

const noncompliance_model_adequacies = ref([])
const noncompliance_model_adequacy_filters = ref({})
const filtered_noncompliance_model_adequacies = ref([])

export default function useNoncomplianceModelAdequacies() {
  const listNoncomplianceModelAdequacies = async () => {
    axios
      .get('/api/noncompliance_model_adequacies/all')
      .then(function (response) {
        noncompliance_model_adequacies.value =
          filtered_noncompliance_model_adequacies.value = response.data.data
      })
      .catch(function () {})
  }

  const updateFilters = async () => {
    let filters = toRaw(noncompliance_model_adequacy_filters.value)

    filtered_noncompliance_model_adequacies.value =
      noncompliance_model_adequacies.value.filter((row) => {
        let noncompliance_model_adequacy = toRaw(row)
        let matches = 0

        for (let key of Object.keys(filters)) {
          if (filters[key].toString().trim() == '') {
            matches++
            continue
          }

          if (
            noncompliance_model_adequacy[key]
              .toString()
              .trim()
              .toLowerCase()
              .normalize('NFD')
              .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), '')
              .includes(
                filters[key]
                  .toString()
                  .trim()
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), ''),
              )
          ) {
            matches++
          }
        }

        return matches == Object.keys(filters).length
      })
  }

  watch(noncompliance_model_adequacy_filters.value, () => {
    updateFilters()
  })

  return {
    noncompliance_model_adequacies: computed(
      () => noncompliance_model_adequacies.value,
    ),
    noncompliance_model_adequacy_filters: noncompliance_model_adequacy_filters,
    filtered_noncompliance_model_adequacies: computed(
      () => filtered_noncompliance_model_adequacies.value,
    ),
    listNoncomplianceModelAdequacies,
  }
}
